import { render } from "./pageMM.vue?vue&type=template&id=8bc1a28c&scoped=true"
import script from "./pageMM.vue?vue&type=script&lang=js"
export * from "./pageMM.vue?vue&type=script&lang=js"

import "./pageMM.vue?vue&type=style&index=0&id=8bc1a28c&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8bc1a28c"]])

export default __exports__